<template>
    <v-dialog v-model="getModalCadastroGradeProduto" max-width="500px" transition="dialog-transition">
        <v-card>
            <v-card-title>
                Cadastro de Grade
            </v-card-title>
            <v-form class="px-3" ref="form">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex md6>
                            <v-text-field dense outlined v-model="getGradeProduto.grade_1" label="Grade 1" class="ml-2 mr-2" :rules="rules.grade_1" @keyup.13="salvar"></v-text-field>	
                        </v-flex>
                        <v-flex md6>
                            <v-text-field dense outlined v-model="getGradeProduto.grade_2" label="Grade 2" class="ml-2 mr-2" :rules="rules.grade_2" @keyup.13="salvar"></v-text-field>	
                        </v-flex>
                        <v-flex md6>
                            <v-text-field dense outlined v-model="getGradeProduto.codigo_barra" label="Código de Barras" class="ml-2 mr-2" @keyup.13="salvar"></v-text-field>	
                        </v-flex>
                        <v-flex md6>
                            <v-text-field dense outlined v-mask="['#,###', '##,###', '###,###']" v-model="getGradeProduto.quantidade_estoque" label="Quantidade" class="ml-2 mr-2" :rules="rules.quantidade_estoque" @keyup.13="salvar"></v-text-field>	
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined color="default" @click="setModalCadastroGradeProduto(false)">Voltar</v-btn>
                    <v-btn outlined color="error" @click="setModalExcluirGradeProduto(true)" v-if="getGradeProduto.id && $helper.verificaPermissao('excluir-grade-produto')">Excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="success" @click="salvar()" v-if="$helper.verificaPermissao('cadastrar-grade-produto') || $helper.verificaPermissao('atualizar-grade-produto')">Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <ModalExcluir />
    </v-dialog>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'
    import ModalExcluir from "@/pages/produto/grade/ModalExcluir"
    export default {
        components: {
            ModalExcluir
        },
        data(){
            return {
                rules: {
                    grade_1: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    grade_2: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    codigo_barra: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    quantidade_estoque: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                }
            }
        },
        computed: {
            ...mapGetters([
            'getModalCadastroGradeProduto',
            'getGradeProduto',
            'getProduto'
            ])
        },
        methods: {
            ...mapActions([
            'salvarGradeProduto',
            'atualizarGradeProduto',
            'excluirGradeProduto',
            'setModalCadastroGradeProduto',
            'setModalExcluirGradeProduto',
            ]),
            salvar(){
                this.getGradeProduto.produto_id = this.getProduto.id
                if(this.$refs.form.validate()){ 
                    if(this.getGradeProduto.id){
                        this.atualizarGradeProduto(this.getGradeProduto)
                    }else{
                        this.salvarGradeProduto(this.getGradeProduto)
                    }
                }
            }
        },
    }
</script>